import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_MINISTRY]: state => state.ministry,
  [getterTypes.GET_MINISTRIES]: state => state.ministries,
};

const actions = {
  async [actionTypes.DO_GET_MINISTRIES]({ commit }, params) {
    const { data } = await HTTP.get('/ministries', { params });
    commit(mutationTypes.SET_MINISTRIES, data.data.ministries);
    return data;
  },
  async [actionTypes.DO_GET_MINISTRY]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/ministries/${id}`, { params });
    commit(mutationTypes.SET_MINISTRY, data.data.ministries[0]);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_MINISTRY](state, ministry) {
    state.ministry = ministry;
  },
  [mutationTypes.SET_MINISTRIES](state, ministries) {
    state.ministries = ministries;
  },
};

export default {
  state: {
    ministry: {},
    ministries: [],
  },
  getters,
  actions,
  mutations,
};
